import { i18n } from "../translate/i18n";
import { isString } from "lodash";

const toastError = (err, toastInstance) => {
  try {
    const safeToast = toastInstance;
    const responseError = err?.response?.data?.error;
    
    // ✅ FIX: Suporta erro como string OU como objeto { code, message }
    let backendError = null;
    if (isString(responseError)) {
      backendError = responseError;
    } else if (responseError?.code) {
      backendError = responseError.code;
    } else if (responseError?.message) {
      backendError = responseError.message;
    }
    
    const message = backendError || (isString(err) ? err : null);

    if (safeToast) {
      if (message) {
        if (backendError && i18n.exists(`backendErrors.${backendError}`)) {
          safeToast.error(i18n.t(`backendErrors.${backendError}`));
        } else {
          safeToast.error(message);
        }
      } else {
        safeToast.error("An error occurred!");
      }
      return;
    }

    if (message) {
      console.error("toastError:", message, err);
    } else {
      console.error("toastError: An unknown error occurred", err);
    }
  } catch (e) {
    console.error("toastError handler failure:", e, err);
  }
};

export default toastError;
